import { Component } from 'preact';

export default class Error extends Component {

	renderError(code, url) {
		switch (code) {
			case 404:
				return ([
					<h3><i className="fa fa-warning text-yellow" /> Oops! Page not found.</h3>,
					<p>
						We could not find the <code>{url}</code> page you were looking for.
						Meanwhile, you may <a href="/">return to dashboard</a>.
					</p>
				]);
			case 500:
			default:
				return ([
					<h3><i className="fa fa-warning text-yellow" /> Oops! That's an error.</h3>,
					<p>
						Something went wrong.
					</p>
				]);
		}
	}

	render({ code, url }) {
		return (
			<div className="row min-content-height no-margin justify-content-center align-items-center">
				<div className="text-center">
					<h2 className="headline text-yellow">{ code }</h2>
					<div className="error-content">
						{ this.renderError(code, url) }
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./components/Error.js